"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var mobx_1 = require("mobx");
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var BlogCommentFormStore = /** @class */ (function () {
    function BlogCommentFormStore(_a) {
        var isLoggedIn = _a.isLoggedIn, defaultNickName = _a.defaultNickName, postCommentPath = _a.postCommentPath;
        var _this = this;
        this.content = '';
        this.updatesNickName = false;
        this.handleChangeNickName = function (nickName) {
            _this.nickName = nickName;
        };
        this.handleChangeEmail = function (email) {
            _this.email = email;
        };
        this.handleChangeContent = function (content) {
            _this.content = content;
        };
        this.handleChangeUpdatesNickName = function (updatesNickName) {
            _this.updatesNickName = updatesNickName;
        };
        this.submitComment = function () {
            var params = {
                blogComment: {
                    nickName: _this.nickName,
                    email: _this.email,
                    content: _this.content,
                    updatesNickName: _this.updatesNickName
                }
            };
            dialog_store_1.default.showDialog({
                title: "送信中...",
                description: "しばらくお待ちください",
                show_time: -1
            });
            return axios_1.default
                .post(_this.postCommentPath, (0, convert_case_keys_1.toSnakeKeys)(params))
                .then(function () {
                dialog_store_1.default.hideDialog();
                dialog_store_1.default.showDialog({
                    title: "投稿が完了しました",
                    description: "承認されると表示されますので、しばらくお待ちください。",
                    btnList: [
                        {
                            title: "閉じる",
                            callback: function () { return dialog_store_1.default.hideDialog(); },
                            customClass: "btn-blue"
                        },
                    ],
                    show_time: -1
                });
            })
                .catch(function (_a) {
                var response = _a.response;
                var data = response.data;
                // FIXME: HIKAKAKU-3030
                dialog_store_1.default.hideDialog();
                if (data && data.version === 'v1') {
                    dialog_store_1.default.showErrorDialog(data.message, data.details);
                }
                else {
                    dialog_store_1.default.showErrorDialog();
                }
            });
        };
        this.isLoggedIn = isLoggedIn;
        this.nickName = defaultNickName || '';
        this.postCommentPath = postCommentPath;
    }
    Object.defineProperty(BlogCommentFormStore.prototype, "disableSubmitButton", {
        get: function () {
            return this.nickName.length === 0 || this.content.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], BlogCommentFormStore.prototype, "nickName", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], BlogCommentFormStore.prototype, "email", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BlogCommentFormStore.prototype, "content", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BlogCommentFormStore.prototype, "updatesNickName", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], BlogCommentFormStore.prototype, "isLoggedIn", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlogCommentFormStore.prototype, "handleChangeNickName", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlogCommentFormStore.prototype, "handleChangeEmail", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlogCommentFormStore.prototype, "handleChangeContent", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlogCommentFormStore.prototype, "handleChangeUpdatesNickName", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlogCommentFormStore.prototype, "submitComment", void 0);
    return BlogCommentFormStore;
}());
exports.default = BlogCommentFormStore;
